<template>
  <b-button
    :class="{ underline: underline, ['link text-' + linkColor]: true }"
    variant="link"
    :to="to"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <slot></slot>
  </b-button>
</template>

<script>
import { BButton } from 'bootstrap-vue'

/**
 * This component provides a link-like button
 */
export default {
  name: 'LinkButton',
  components: {
    BButton
  },
  props: {
    to: {},
    linkColor: {
      type: String,
      default: 'secondary' // acceptable values  - primary/secondary
    },
    underline: {
      type: Boolean
    },
    disabled: Boolean
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.link {
  transition: color ease-in 200ms;
}

.link:hover {
  color: $primary !important;
}
.text-brand:hover {
  color: $brand !important;
}
.underline {
  text-decoration: underline;
}
</style>
